const Footer = () => (
  <footer className="p-3 text-center !bg-transparent !shadow-none border-t-[0.5px] !border-neutral300 backdrop-blur-3xl">
    <img alt="logo" className="max-w-[40px] m-auto !mb-4" src="/logo.svg" />
    <p>© 2024 Klugerhans. All rights reserved.</p>
  </footer>
);

export default Footer;
